import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function putConfigurationProfilesDefault(
  profileId: number,
  defaultSet: boolean
) {
  return fromFetch(
    new Request(
      fleetEnvironment.configurationProfilesDefaultUrl(profileId, defaultSet),
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
      }
    )
  ).pipe(ignoreData());
}
